export default "__VITE_ASSET__DCD1tL6g__"